import { withDependencies, optional } from '@wix/thunderbolt-ioc'
import type { TpaHandlerProvider } from '@wix/thunderbolt-symbols'
import type { IBsiManager } from 'feature-business-logger'
import { BsiManagerSymbol } from 'feature-business-logger'

export const ReportVisitorActivityHandler = withDependencies(
	[optional(BsiManagerSymbol)],
	(bsiManager?: IBsiManager): TpaHandlerProvider => ({
		getTpaHandlers() {
			return {
				reportVisitorActivity: bsiManager ? bsiManager.reportActivity : () => {},
			}
		},
	})
)
